const dns_management = {
	error_while_fetching_dns_records:
		"Beim Abrufen der DNS-Einträge ist ein Fehler aufgetreten. Wenn das Problem weiterhin besteht, wenden Sie sich bitte an den Kundendienst.",
	external_nameservers:
		"Die DNS-Einträge können nicht bearbeitet werden, da diese Domain externe Nameserver verwendet.",
	not_available:
		"Die DNS-Einträge sind nicht verfügbar, da die Domain nicht (mehr) unter Ihrer Verwaltung steht.",
	title: "DNS-Verwaltung",
	update_success: "Die neuen DNS-Einstellungen wurden erfolgreich gespeichert.",
};

export default dns_management;
